/**
 * Profile data rows subcomponent
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Spinner from 'components/Spinner';
import { getProfile } from './getProfile';
import messages from './messages';

function ProfileRows({ userData }) {
  if (!userData || userData.loading) {
    return <Spinner />;
  }

  return getProfile(userData).map(o => (
    <React.Fragment key={o.key}>
      <dt>
        <FormattedMessage {...messages[o.key]} />
      </dt>
      <dd className="mb-3">{o.value}</dd>
    </React.Fragment>
  ));
}

ProfileRows.propTypes = {
  userData: PropTypes.object,
};

export default ProfileRows;
